import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../ContactModal.css';
import { FormControl, FormLabel, Input, Button, DialogActions, Typography } from '@mui/joy';


const AddressPage = ({ setPage, setOpen, setAddress }) => {
    const [addressValue, setAddressValue] = useState('');
  
    const handleInputChange = (event) => {
        setAddressValue(event.target.value);
    };

    return (
        <>
        <Typography level="h3">Let’s Find Your Representative</Typography>
        <Typography level="body-md">
            Your voice matters, and your representative is here to listen. 
            To connect you with the right person, we need your address. 
            This ensures your message reaches the representative for your district. 
            We do not store your address in any database.
        </Typography>
        <FormControl>
            <FormLabel>Address</FormLabel>
            <Input
                placeholder="e.g. 123 Cherry St Earlham, IA 50072"
                variant='outlined'
                value={addressValue}
                onChange={handleInputChange}
                sx={{ width: '100%' }}
            />
        </FormControl>
        <DialogActions>
            <Button variant="solid" color="primary" onClick={() => {
                setPage('stance');
                setAddress(addressValue)
            }}>
                Next: Share your opinion
            </Button>
            <Button variant="plain" color="neutral" onClick={() => setOpen(false)}>
                Cancel
            </Button>
        </DialogActions>
        </>
    );
};

// Prop types for our Component
AddressPage.propTypes = {
    setOpen: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    setAddress: PropTypes.func.isRequired,
}
 
// Default Props for our Component
AddressPage.defaultProps = {
}

export default AddressPage;